import { AsSearchBar, LabelledTickbox, AsButton, IconClose, useModal } from '@adserve/adserve-react-components';
import React, { useContext, useState, useEffect } from 'react';
import { AirtimePlanningContext } from '../../../../contexts/AirtimePlanningContext';
import {
    GetActivePropertiesDetails,
    GetPropertyCostingTypes,
    GetPropertyTotals,
    GetSandPPropertyDefinition,
    GetStations,
    LoadPropertyDealPrice
} from '../../../../services/CampaignsDataService';
import AsSelectWithPlaceholder from '../../../generic/AsSelectWithPlaceholder';
import { labelStyle } from '../CampaignBriefStyles';
import PropertySelectionTable from './PropertySelectionTable';
import ReactDOM from 'react-dom';
import moment from 'moment';

export const headerStyle = {
    display: 'flex',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500,
    justifyContent: 'left'
};

const labelledBoxStyle = {
    display: 'Flex',
    justifyContent: 'left',
    fontSize: 14,
    gap: 20
};

export const createButton = {
    width: 105,
    height: 40,
    fontSize: 14,
    fontWeight: 'bold'
};

const searchBoxStyle = {
    display: 'grid',
    gridAutoFlow: 'column',
    width: 'max-content',
    margin: 'auto'
};

const PropertySelectionModal = ({
    setReadOnlyProperty,
    campaign,
    updateCampaign,
    setMinDateActiveProperty,
    setMaxDateActiveProperty,
    isShowing,
    propertyTotals,
    setPropertyTotals,
    recalcTotals,
    setIsShowing,
    updateWinPrice
}) => {
    const { addMessage } = useModal();
    const { propertyStats, setPropertyStats } = useContext(AirtimePlanningContext);
    const [activeProperties, setActiveProperties] = useState([]);
    const [sponsorships, setSponsorships] = useState(true);
    const [partnerships, setPartnerships] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [stations, setStations] = useState([]);
    const [propertyCostingTypes, setPropertyCostingTypes] = useState([]);
    const [selectedStationId, setSelectedStationId] = useState('00000000-0000-0000-0000-000000000000');
    const [selectedPropertyCostingTypeId, setSelectedPropertyCostingTypeId] = useState(
        '00000000-0000-0000-0000-000000000000'
    );
    const [newSelectedProperties, setNewSelectedProperties] = useState([]);
    const [propertyStatusMessage, setPropertyStatusMessage] = useState('');
    const [checkedProperties, setCheckedProperties] = useState([]);

    const [includeRunning, setIncludeRunning] = useState(false);

    const includeRunningChange = () => {
        setIncludeRunning(!includeRunning);
    };

    const overlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1040,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.4)'
    };

    const wrapperStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1050,
        width: '100%',
        height: '100%',
        overflowX: 'hidden',
        overflowY: 'auto',
        outline: 0
    };

    const bodyStyle = {
        position: 'fixed',
        boxSizing: 'border-box',
        height: 'auto',
        width: 'minmax(50%, 90%)',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        padding: '25px 40px',
        borderRadius: 15,
        backgroundColor: '#FFFFFF',
        boxShadow: '3px 2px 11px 0 rgba(0,0,0,0.33)',
        fontFamily: 'Roboto',
        fontSize: 22,
        fontWeight: 500,
        zIndex: 1060,
        display: 'grid',
        gridAutoFlow: 'row',
        gap: 20
    };

    const findMinDate = () => {
        const dates = [];
        activeProperties?.forEach((b) => {
            dates.push(new Date(b['startDate']));
        });
        const minDate = new Date(Math.min.apply(null, dates));
        return minDate;
    };

    const findMaxDate = () => {
        const dates = [];
        activeProperties?.forEach((b) => {
            dates.push(new Date(b['endDate']));
        });
        const maxDate = new Date(Math.max.apply(null, dates));
        return maxDate;
    };

    const loadData = async () => {
        const stationTask = GetStations();
        GetPropertyCostingTypes().then((res) => {
            setPropertyCostingTypes(res?.data);
        });

        let propDetails = await GetActivePropertiesDetails(
            selectedStationId,
            searchTerm,
            sponsorships,
            partnerships,
            includeRunning,
            selectedPropertyCostingTypeId
        );

        console.log(':propDetails? ', propDetails);

        // Filter any currently selected ones so they don't display in the table
        propDetails = propDetails.filter((p) => {
            return !propertyStats.find((s) => {
                return (
                    s.sandPPropertyId === p.id &&
                    (p?.propertyDurationType === 1 ||
                        p?.propertyDurationType === '1' ||
                        p?.propertyDurationType === 'Finite')
                );
            });
        });

        for (const row of propDetails) {
            if (row.propertyParentId === null) {
                row.propertyParentId = window.emptyGuid;
            }

            row.defaultSpots = row.spotCount;
            row.defaultImpacts = row.totalImpacts;
            row.defaultEpisodeCount = row.episodeCount;
            row.defaultPropertyListPrice = row.propertyListPrice;
        }
        setActiveProperties(propDetails);
        const stationRes = await stationTask;
        const filteredStationRes = stationRes?.filter(
            (s) => s?.name === 'All' || propDetails?.some((p) => p?.linkedStationNames?.includes(s?.name))
        );
        setStations(filteredStationRes);
    };

    useEffect(() => {
        loadData();
    }, [
        selectedStationId,
        searchTerm,
        sponsorships,
        partnerships,
        selectedPropertyCostingTypeId,
        propertyStats,
        includeRunning
    ]);

    useEffect(() => {
        setNewSelectedProperties([...propertyStats]);
    }, [propertyStats]);

    useEffect(() => {
        setMinDateActiveProperty(new Date(findMinDate()));
        setMaxDateActiveProperty(new Date(findMaxDate()));
    }, [activeProperties]);

    const onSponsorshipsClick = () => {
        setSponsorships(!sponsorships);
    };

    const onPartnershipsClick = () => {
        setPartnerships(!partnerships);
    };

    const handleCancelButton = () => {
        setPropertyStats([...propertyStats]);
        setIsShowing(false);
    };

    const handleApplyButton = async () => {
        var propsWithOffairs = newSelectedProperties.filter((p) => {
            return p.offairActivities?.length > 0;
        });
        let hassOffairsInPast = false;
        propsWithOffairs.forEach((p) => {
            p.offairActivities.forEach((oa) => {
                var sDate = new Date(oa.startDate);
                var today = new Date();
                sDate.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);
                if (sDate <= today) {
                    hassOffairsInPast = true;
                }
            });
        });

        if (!hassOffairsInPast) {
            doApply();
        } else {
            addMessage({
                message: window.translate(
                    'Selected Properties have Off-Air Costs that are in the past. Cannot add properties'
                ),
                buttons: [{ text: window.translate('Ok') }]
            });
        }
    };

    const doApply = async () => {
        campaign.modified = true;
        setReadOnlyProperty(false);
        newSelectedProperties.map((prop, b) => {
            // Getting every Definition in the modal is infeasible but we definitely need it for the attached properties so get for the unsaved properties we just added
            if (Date.parse(prop.startDate) < new Date() && prop.id === window.emptyGuid) {
                prop.dateChanged = true;
                const newDate = moment(new Date());
                newDate.add('days', 1);
                prop.startDate = newDate;
            }
            if (prop.hasOwnProperty('scheduledContentSpotCount')) {
                // then we are a new propertyselection so initialise accordingly
                prop.linkedStationNames = JSON.parse(prop.linkedStationNames).formattedName;
                prop.propertyType = prop.propertyTypeName;

                prop.scheduledSpotCount = prop.scheduledContentSpotCount;
                prop.liveSpotCount = prop.liveReadSpotCount;
                prop.featureCount = prop.featureSpotCount;
                prop.advertorialCount = prop.advertorialSpotCount;
                prop.partnerAirtimeCount = prop.partnershipSpotCount;
                prop.reach = prop.totalReach;
                prop.impacts = prop.totalImpacts;

                prop.listPrice = prop.propertyListPrice;
                prop.dealPrice = 0;
                prop.sandPBudget = 0;
            }
        });

        setPropertyStats([...newSelectedProperties]);
        recalcTotals(newSelectedProperties);
        //    updateCampaign();
        setIsShowing(false);
    };

    const handleStationChange = (event) => {
        setSelectedStationId(event.target.value);
    };

    const handlePropertyCostingTypeChange = (event) => {
        setSelectedPropertyCostingTypeId(
            event.target.value === '-1' ? '00000000-0000-0000-0000-000000000000' : event.target.value
        );
    };

    const handleSearchUpdate = (value) => {
        setSearchTerm(value);
    };

    const onCloseClick = async () => {
        setIsShowing(false);
        await loadData();
    };

    return isShowing
        ? ReactDOM.createPortal(
              <div style={wrapperStyle}>
                  <div style={overlayStyle} />

                  <div style={bodyStyle}>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span>{window.translate('Property Catalogue')}</span>
                          <LabelledTickbox
                              title={window.translate('Include Running')}
                              value={includeRunning}
                              onClick={includeRunningChange}
                          ></LabelledTickbox>
                          <div style={{ display: 'grid', gridAutoFlow: 'row', gap: 20 }}>
                              <IconClose size={20} onClick={onCloseClick} />
                          </div>
                      </div>

                      <div style={{ display: 'flex', gap: 50 }}>
                          <div style={labelledBoxStyle}>
                              <AsSelectWithPlaceholder
                                  id='property-costing-type-input'
                                  name='sandPPropertyCostingTypeId'
                                  placeholderText={window.translate('All')}
                                  title={window.translate('Property Type')}
                                  values={propertyCostingTypes}
                                  value={selectedPropertyCostingTypeId}
                                  onChange={handlePropertyCostingTypeChange}
                                  selectStyleOverride={{ width: 403 }}
                              />
                          </div>
                          <div style={searchBoxStyle}>
                              <AsSearchBar
                                  id='propertySearch'
                                  placeholder={window.translate('Search Properties...')}
                                  width={395}
                                  height={42}
                                  currentSearchTerm={searchTerm}
                                  onSearchUpdate={handleSearchUpdate}
                              />
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'end' }}>
                              <AsSelectWithPlaceholder
                                  id='station-input'
                                  name='transmitterId'
                                  placeholderText={window.translate('All')}
                                  title={window.translate('Station')}
                                  values={stations}
                                  value={selectedStationId}
                                  onChange={handleStationChange}
                                  selectStyleOverride={{ width: 403 }}
                              />
                          </div>
                      </div>

                      <PropertySelectionTable
                          activeProperties={activeProperties}
                          newSelectedProperties={newSelectedProperties}
                          setNewSelectedProperties={setNewSelectedProperties}
                          setPropertyStatusMessage={setPropertyStatusMessage}
                          checkedProperties={checkedProperties}
                          setCheckedProperties={setCheckedProperties}
                      />

                      <div style={{ display: 'flex' }}>
                          <div style={{ display: 'flex', justifyContent: 'flex-start', width: '22.5%' }}>
                              <span style={{ fontFamily: 'Roboto', fontSize: 14, color: '#9B111E', fontWeight: 400 }}>
                                  {window.translate(propertyStatusMessage)}
                              </span>
                          </div>
                          <div
                              style={{
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                  width: '77.5%',
                                  alignItems: 'right',
                                  gap: 16
                              }}
                          >
                              <AsButton style={createButton} handleClick={handleCancelButton} useSecondaryStyle>
                                  {window.translate('Cancel')}
                              </AsButton>
                              <AsButton style={createButton} handleClick={handleApplyButton}>
                                  {window.translate('Apply')}
                              </AsButton>
                          </div>
                      </div>
                  </div>
              </div>,
              document.body
          )
        : null;
};

export default PropertySelectionModal;
